import Axios from 'axios';

// Global axios interceptor to handle 401 Unauthorized errors (expired JWT)
Axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            // Token expired or invalid - clear session and redirect to login
            console.warn('401 Unauthorized - Redirecting to login');
            sessionStorage.clear();
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default Axios;
